import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Divider, Typography } from "@mui/material";
import Grid from "@mui/material/GridLegacy";
import { AuthContext } from "components/authProvider/authProvider";
import { host } from "config";
import { useContext } from "react";

export type FormSubmissionDetail = {
  Form_ID: string;
  Submission_ID: string;
  Form_Name: string;
  User_Email: string;
  Submission_JSON: { [key: string]: any };
  Response_Code: string;
  Error_Message: string;
  Entry_Date: string;
  Update_Date: string;
  Files: { fileName: string; fullPath: string }[];
};

type FormSubmissionDetailsDialogProps = {
  open: boolean;
  onClose: () => void;
  formSubmissionDetail: FormSubmissionDetail;
};

function prettifyKeyName(key: string): string {
  return key
    .replace(/([A-Z])/g, " $1")
    .replace(/^./, (c) => c.toUpperCase())
    .trim();
}

export const FormSubmissionDetailModal: React.FC<FormSubmissionDetailsDialogProps> = ({
  open,
  onClose,
  formSubmissionDetail,
}) => {
  const authContext = useContext(AuthContext);
  if (!authContext) {
    throw new Error("AuthContext is undefined");
  }
  const { currentUser } = authContext;
  function downloadFile(file: { fileName: string; fullPath: string }) {
    let params = new URLSearchParams({ submissionID: formSubmissionDetail.Submission_ID, fileName: file.fullPath });

    currentUser.getIdToken(false).then((tk) => {
      fetch(`${host}/api/Reporting/FormSubmissions/downloadFileAttachment?${params}`, {
        method: "GET",
        headers: {
          authorization: `Bearer ${tk}`,
        },
      }).then((resp) => {
        console.log([...resp.headers.entries()]);
        if (resp.ok) {
          resp.blob().then((blob) => {
            const objectUrl = URL.createObjectURL(blob);

            const link = document.createElement("a");
            link.href = objectUrl;
            link.download = file.fileName;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            URL.revokeObjectURL(objectUrl);
          });
        } else {
          resp.json().then((respJson) => {
            alert(respJson.error);
          });
        }
      });
    });
  }

  return (
    <Dialog open={open} onClose={onClose} aria-labelledby="dialog-title" maxWidth="md" fullWidth>
      <DialogTitle id="dialog-title">Submission Details</DialogTitle>
      <DialogContent>
        {formSubmissionDetail && (
          <Grid container spacing={2}>
            {/* Provider Information */}
            <Grid item xs={12}>
              <Typography variant="h6">Form Information</Typography>
              <Divider />
              <Typography variant="body1">
                <strong>Form ID:</strong> {formSubmissionDetail.Form_ID}
              </Typography>
              <Typography variant="body1">
                <strong>Form Name</strong> {formSubmissionDetail.Form_Name}
              </Typography>
              <Typography variant="body1">
                <strong>Submission ID</strong> {formSubmissionDetail.Submission_ID}
              </Typography>
              <Typography variant="body1">
                <strong>User Email</strong> {formSubmissionDetail.User_Email}
              </Typography>
              <Typography variant="body1">
                <strong>Response Code</strong> {formSubmissionDetail.Response_Code}
              </Typography>
              <Typography variant="body1">
                <strong>Error Message</strong> {formSubmissionDetail.Error_Message}
              </Typography>
              <Typography variant="body1">
                <strong>Entry Date</strong> {formSubmissionDetail.Entry_Date}
              </Typography>
              <Typography variant="body1">
                <strong>Update Date</strong> {formSubmissionDetail.Update_Date}
              </Typography>
              <Divider />
              <Typography variant="h6">Form Submission</Typography>
              {Object.entries(formSubmissionDetail.Submission_JSON).map(([key, answer]) => (
                <Typography variant="body1">
                  <strong>{prettifyKeyName(key)}</strong> {answer}
                </Typography>
              ))}
              <Divider />
              {formSubmissionDetail.Files.map((file) => (
                <Typography variant="body1">
                  <strong>{file.fileName}</strong>
                  <Button
                    variant="contained"
                    size="small"
                    style={{ marginLeft: "8px", backgroundColor: "#004e9d" }}
                    onClick={() => downloadFile(file)}
                  >
                    Download File
                  </Button>
                </Typography>
              ))}
            </Grid>
          </Grid>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary">
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};
